import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

const fetchSiteFinancialStatus = (retailerId) => {
  const { url } = DepsService.rest.widgets.siteFinancialStatus;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default {
  fetchSiteFinancialStatus,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/site-financial-status.api.js